/**
 * @fileoverview Agent definition for scene-architect-v2.
 *
 * Creates a set of scenes for a given chapter based on its key events.
 *
 * @category narrative.chapters.scenes
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'scene-architect-v2',
  kind: 'primitive',
  name: 'Scene Architect',
  description: 'Creates a set of scenes for a given chapter based on its key events.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.chapters.scenes',
    usedBy: [
      'primitives/use-scene-architect-v2.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'chapter-planner-v2',
      'single-chapter-story-generator-v2',
    ],
  },
};
